import { Badge } from '@/components/ui/badge';

export const renderAgentStatusBadge = (status: string) => {
  switch (status) {
    case 'Draft':
      return <Badge variant="secondary">Draft</Badge>;
    case 'Published':
      return <Badge variant="default">Published</Badge>;
  }
};

export const getStatusBadgeVariant = (status: string) => {
  switch (status.toLowerCase()) {
    case 'success':
      return 'success';
    case 'pending':
      return 'pending';
    case 'active':
    case 'completed':
      return 'default';
    case 'cancelled':
    case 'failed':
      return 'fail';
    default:
      return 'outline';
  }
};
